define('C3.ShoppingExtensions.YouMayAlsoNeed.CollectionUpdated',
  [
  'C3.ShoppingExtensions.PDP.Model',
  'Utils',
  'SCCollection',
  'SCModel',
  'underscore'
  ],
  function (NewArrivalsModel, Utils,SCCollectionModule,SCModelModule,_) {
    'use strict';

     var SCCollection = SCCollectionModule.SCCollection;
     var SCModel = SCModelModule.SCModel;


     function YouMayAlsoNeedCollectionUpdated(models, options) {
      SCCollection.call(this, models, options);

      this.model = SCModel;

      this.customFilters = options && options.filters;


      this.url = function url () {
        return Utils.getAbsoluteUrl(
                getExtensionAssetsPath(
                    "services/PDP.Service.ss"
                )
              )
      }

       this.parse = function parse(response) {
        this.totalRecordsFound = response.totalResultsCount;
        this.recordsPerPage = 50;
        console.log(response)
        var carouselData = response.resp;
        //console.log(carouselData.items)
        return response;
      }

      this.update = function update(options){
         const data = {
              filter: options.filter,
              pageNumber: options.page || 1,
              resultsPerPage: options.resultsPerPage || 50,
              keyword : options.keyword
          };

         // console.log(data)
          
          this.fetch({
              data: data,
              reset: true,
              killerId: options.killerId
          });
      }
    }

    YouMayAlsoNeedCollectionUpdated.prototype = Object.create(SCCollection.prototype);
    YouMayAlsoNeedCollectionUpdated.prototype.constructor = YouMayAlsoNeedCollectionUpdated;

    return YouMayAlsoNeedCollectionUpdated;
    
  }
);
